import {debounce, delay, map} from 'lodash'

const WAIT_TIME = 40000

const SELECTORS = {
  SCREENSAVER: '#Screensaver',
  SCREENSAVER_WRAP: '#ScreensaverWrap',
  SCREENSAVER_LOGO: '#ScreensaverLogo',
}

const $screensaver = $(SELECTORS.SCREENSAVER)
const $screensaverWrap = $(SELECTORS.SCREENSAVER_WRAP)
const logoImage = document.getElementById(SELECTORS.SCREENSAVER_LOGO.substr(1))
const CLASS_SCREENSAVER_VISIBLE = 'screensaver-wrap--is-visible'

const EVENT_NAMESPACE = 'screensaver'
const INTERRUPTION_EVENTS = ['click', 'mouseenter', 'keyup', 'touchstart', 'touchmove', 'touchend']
const EVENTS = map(INTERRUPTION_EVENTS, (EVENT_NAME) => `${EVENT_NAME}.${EVENT_NAMESPACE}`).join(' ')

let IS_RUNNING = false
let TIMEOUT_ID = 0

export default { start, stop, startListener, stopListener }

function start() {
  if (IS_RUNNING || window.FOOFOO.screensaverIsDisabled) {
    return
  }

  $screensaverWrap.addClass(CLASS_SCREENSAVER_VISIBLE)
  IS_RUNNING = true
  $(document).trigger('screensaver:open')
}

function stop() {
  if (!IS_RUNNING) {
    return
  }

  $screensaverWrap.removeClass(CLASS_SCREENSAVER_VISIBLE)
  IS_RUNNING = false
  $(document).trigger('screensaver:close')
}

function startListener() {
  TIMEOUT_ID = delay(start, WAIT_TIME)
  $(window).on(EVENTS, debounce(resetListener, 200))
}

function stopListener() {
  clearTimeout(TIMEOUT_ID)
  stop()
  $(window).off(EVENTS)
}

function resetListener() {
  stopListener()
  startListener()
}



// WEBPACK FOOTER //
// ./screensaver.js